import classNames from 'classnames';
import * as React from 'react';
import { Image } from '../../../interfaces/merchants/resources/books';
import BooksMenu from './BooksMenu';
import BooksMenuDescWithButton from './BooksMenuDescWithButton';

import css from './BooksMenuItem.module.scss';

interface Props {
  className?: string;
  courseName: string;
  image?: Image;
  price?: string;
  text: string;
  duration?: number; // second
  value?: number;
  postable: boolean;
  onClick?: (e: React.MouseEvent) => void;
}

const BooksMenuItem = ({
  className,
  courseName,
  image,
  price,
  text,
  duration,
  value,
  postable,
  onClick,
}: Props) => {
  const classes = classNames(css.BooksMenuItem, className);

  return (
    <div className={classes}>
      <div className={css.BooksMenuItem__Header}>
        {image && image.thumb && image.thumb.url && (
          <img
            className={css.BooksMenuItem__Image}
            src={image.thumb.url}
            alt=""
          />
        )}
        <BooksMenu menuName={courseName} price={price} duration={duration} />
      </div>
      <BooksMenuDescWithButton
        className={css.BooksMenuItem__Description}
        value={value}
        postable={postable}
        onClick={onClick}
        text={text}
      />
    </div>
  );
};

export default BooksMenuItem;
